import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { CriticalityLevelEnum } from '@core/enums/criticality-level.enum';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificacaoCFCModel } from '@core/models/gestao/notificacao-cfc.model';
import { NotificationCFCService } from '@core/services/apis/gestao/notification-cfc.service';
import { TypeContentNotificationsEnum } from '@core/enums/type-notifications.enum';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {

  notifications: Array<NotificacaoCFCModel>;
  formNotification: UntypedFormGroup;
  read: UntypedFormControl = new UntypedFormControl();
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: ['Anterior', 'Próximo'],
    items: 1,
    nav: true,
  }
  private _subscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) listNotifications: Array<NotificacaoCFCModel>,
    private _notificationCfcService: NotificationCFCService,
    private _sanitizer: DomSanitizer,
    private _formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
  ) {
    this._subscription = new Subscription();
    this.notifications = listNotifications;
    this.notifications.map(x => x.notificacaoId = x.notificacaoId.toString())
  }

  ngOnInit(): void {
    this._iniForm();
    this.mapNotifications();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  mapNotifications(): void {
    this.notifications.map(item => {
      if (item.notificacao.tipoConteudo == TypeContentNotificationsEnum.VIDEO)
        item.notificacao.linkConteudo = this.getYoutubeEmbedVideo(item.notificacao.linkConteudo);

      if (item.notificacao.nivelCriticidade == CriticalityLevelEnum.HIGH)
        return item;
    });
  }

  onRead(notification: NotificacaoCFCModel): void {
    this.formNotification.get(`notification_` + notification.id).disable();
    this.formNotification.get(`notification_` + notification.id).setValue(true);
    notification.lido = true;

    this._subscription.add(
      this._notificationCfcService.saveRead(notification).subscribe()
    );
  }

  getYoutubeEmbedVideo(link: string) {
    var videoId = link.split('v=')[1];
    var ampersandPosition = videoId.indexOf('&');
    if (ampersandPosition != -1) {
      videoId = videoId.substring(0, ampersandPosition);
    }

    let result = `https://www.youtube.com/embed/${videoId}?controls=0`;
    return this._sanitizer.bypassSecurityTrustResourceUrl(result) as string;
  }

  openNewUrl(url) {
    window.open(url, '_blank').focus();
  }

  private _iniForm(): void {
    this.formNotification = this._formBuilder.group({});
    this.notifications.forEach(
      x => {
        this.formNotification.addControl('notification_' + x.id, this._formBuilder.control(''));
      }
    )
  }
}

